module.exports = __webpack_public_path__ + "img/ferris-wheel.9e909499.svg";